export const cookieConstants = {
  TOKEN: "remember_token",
  USER: "user_info",
};
